module.exports = __webpack_public_path__ + "static/media/zing-rewards.d1290b2e.webp";